export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4720.e0f8be5b.jpg";